import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '@env';
import {Store} from '@ngxs/store';
import {AuthState} from '@shared/state/auth/auth.state';
import {Database, onValue, ref, onChildAdded, update} from '@angular/fire/database';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  headers: HttpHeaders;
  apiUrl: string;

  constructor(private http: HttpClient, private store: Store, private db: Database) {
    this.apiUrl = environment.apiUrl;
  }

  getUrl(url): string {
    return `${this.apiUrl}/${url}`;
  }

  async getAlerts(callback: any): Promise<any> {
    const userId = this.store.selectSnapshot(AuthState.getUserID);

    if (!userId) {
      return Promise.resolve([]);
    }
    const path = `users/${userId}/alerts`;
    const dbRef = ref(this.db, path);
    return onChildAdded(dbRef, callback);
  }

  resolveAlert(alertId: string) {
    const userId = this.store.selectSnapshot(AuthState.getUserID);
    const timestamp = parseInt(moment().format('YYYYMMDDHHmmss'));

    if (!userId || !alertId) {
      return Promise.resolve(false);
    }

    const path = `users/${userId}/alerts/${alertId}`;
    const dbRef = ref(this.db, path);
    return update(dbRef, {
      isRead: true,
      updatedAt: timestamp
    });
  }
}
